// Import model
import { MultiSelectFieldOptions } from '../models/MultiSelectFieldOptions';

// Import base class serializer
import { SelectFieldOptionsSerializer } from './SelectFieldOptionsSerializer';

// Import dependency types (models and enums used in properties)
import { FieldOptions } from '../models/FieldOptions';

// Import dependency serializers (for complex types)
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for MultiSelectFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class MultiSelectFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a MultiSelectFieldOptions instance
   */
  static deserialize(json: string): MultiSelectFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a MultiSelectFieldOptions instance
   */
  static fromObject(obj: any): MultiSelectFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to MultiSelectFieldOptions');
    }


    const instance: MultiSelectFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      items: obj['Items'] as string | undefined,
      allowUnknown: obj['AllowUnknown'] as boolean | undefined,
      _4Ff778B7: obj['_4ff778b7'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of MultiSelectFieldOptions instances
   */
  static deserializeArray(json: string): MultiSelectFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a MultiSelectFieldOptions instance to a JSON string
   */
  static serialize(instance: MultiSelectFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a MultiSelectFieldOptions instance to a plain object
   */
  static toObject(instance: MultiSelectFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'Items': instance.items,
      'AllowUnknown': instance.allowUnknown,
      '_4ff778b7': instance._4Ff778B7,
    };
  }

  /**
   * Serializes an array of MultiSelectFieldOptions instances to a JSON string
   */
  static serializeArray(instances: MultiSelectFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
